<template>
  <div class="conmain">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-input placeholder="视频名称"  v-model="search_value" @keyup.enter.native="search_click()"  prefix-icon="el-icon-search"   style="width: 20%;  " ></el-input>
      <div class="right">
        <span style="line-height: 40px; margin-right: 2rem; ">内部资料，请勿外传</span>
        <el-button type="success" round  @click="down_video()">导出视频列表</el-button>
      </div>
    <el-row>
      <el-col class="eachc" v-for="(val,key) in video_list.data" :key="key">
        <div   v-if="val.status=='2'" >
          <div  @click="operation(val.num,'enable')" style="position:relative;">
            <span class="operation_div">启用</span>
            </div>
           <div  style="display:block" class="mask">
      <!-- 遮罩层 -->
           <el-card :body-style="{ padding: '10px','cursor':'pointer' }">
            <div class="imgh">
              <img :src="val.img"
                class="image">
            </div>

            <div style="padding: 5px;">
              <h3 style="margin: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{val.name}}</h3>
              <div class="bottom clearfix">
                <p style="margin: 0;" class="left">{{val.level}}</p>
                <p style="margin: 0;" class="right">{{val.teacher}}</p>
              </div>
            </div>
          </el-card>
          </div>
         </div>
          <!-- 五遮罩层 -->
          <div v-if="val.status=='1'">
           <div style="position:relative;">
             <span class="operation_div"  @click="operation(val.num,'disable')">禁用</span></div>
            <el-card  :body-style="{ padding: '10px','cursor':'pointer' }" @click.native="watch_video(val.num)">
              <div class="imgh">
                <img :src="val.img"
                  class="image">
              </div>

              <div style="padding: 5px;">
                <h3 style="margin: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{val.name}}</h3>
                <div class="bottom clearfix">
                  <p style="margin: 0;" class="left">{{val.level}}</p>
                  <p style="margin: 0;" class="right">{{val.teacher}}</p>
                </div>
              </div>
            </el-card>
            </div>
      </el-col>
    </el-row>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="video_list.current_page" :page-sizes="[8, 16, 24, 32]" :page-size="video_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="video_list.total">
      </el-pagination>
    </div>
  </div>

</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        liad_show:false,
        search_value:'',
        video_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 8,
        },
      }
    },
    components: {
       load:load
    },
    mounted:function(){
      this.get_video();
    },

    methods: {
       operation(val,type){
                //enable启用    disable禁用
               let _this=this
               _this.axios.post('/v2/c_resource/change_video_status',{data:{'type':'video','num':val,'type':'0'}}).then(function(res) {
                 if(res.status=='200'){
                   if(res.data.code=='1'){
                     _this.$message.success(res.data.msg)
                     _this.get_video()
                   }else{
                     _this.$message.error(res.data.msg)
                   }
                 }else{
                   _this.$message.error('服务器内部错误')
                 }
               }).catch(function(error) {
                 _this.$message.error('服务器内部错误')
               });
               _this.get_video()
             },
      search_click(){
        this.get_video()
      },
      get_video(){
        let _this=this;
        _this.axios.get('/v2/c_resource/get_video',{params:{'page':_this.video_list.current_page,'limit':_this.video_list.per_page,'type':'0','keyword':_this.search_value}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.video_list=res.data.data
              _this.video_list.per_page=parseInt(_this.video_list.per_page)
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      handleSizeChange(val) {
        this.video_list.current_page = 1;
        this.video_list.per_page = val
        this.get_video()
      },
      handleCurrentChange(val) {
        let _this=this
        _this.video_list.current_page = val
        _this.get_video()
      },

      down_video(){
        let _this=this
        _this.liad_show=true
        _this.axios.post('/v2/c_resource/down_video',{data:{}},{responseType:'blob'}).then(function(res) {
          if(res.status=='200'){
            const blob = new Blob([res.data],{type: 'aplication/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
            const elink = document.createElement('a')
            elink.download = '平台视频列表清单.xlsx';
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
            _this.liad_show=false
          }else{
            _this.$message.error('服务器内部错误')
            _this.liad_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.liad_show=false
        });
      },

      watch_video(num){
        let routeData = this.$router.resolve({
          query: {num:num,type:0,resource:'v'},
          path:'/courseplay'
        });
        window.open(routeData.href, '_blank');
      },

    },

  }
</script>

<style scoped>
  .operation_div{
    cursor: pointer;
    position: absolute;
    right: 0;
    z-index: 1000;
    top: -1.5rem;
  }
 .mask{
        opacity:0.5;
        width:100%;
        height:100%;
        background-color:white;
        z-index:998;
  }
  .conmain {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  /* 卡片 */
  .el-row {
    width: 100%;
  }

  .image {
    width: 100%;
    display: block;
    height: 100%;
    position: absolute;
  }

  .imgh {
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }

  .eachc {
    margin: 10px;
    width: calc(25% - 20px);
    margin-top: 2rem;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/course/YzCourse/Video.vue